import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSavedNewsByUser, setSavedNews } from '../../Reducers/actions/newsActions';
import styles from './Library.module.scss';
import NewsItem from '../../components/NewsItem/NewsItem';
import CommentSection from '../../components/CommentSection/CommentSection';
import NewsItemSkeleton from '../../components/NewsItem/NewsItemSkeleton';
import { setTopNavbar } from '../../Reducers/actions/navbarActions';

const SavedNews = () => {
  const dispatch = useDispatch();
  
  // Combined selector for better performance
  const { userId, savedNews, selectedNews, fetchSaved, isLoadingData } = useSelector(state => ({
    userId: state.auth.user?.user_id,
    savedNews: state.news.savedNews,
    selectedNews: state.news.selectedNews,
    fetchSaved: state.news.fetchSaved,
    isLoadingData: state.news.loading
  }));
  
  // Memoized loading logic to prevent infinite loading in saved news navigation
  const loading = useMemo(() => {
    return isLoadingData && (!savedNews || !fetchSaved);
  }, [isLoadingData, savedNews, fetchSaved]);

  const [showComments, setShowComments] = useState(false);

  useEffect(() => {
    dispatch(setTopNavbar({
      title: 'Favourite News',
      showBackArrow: true,
    }))
  }, [])

  useEffect(() => {
    if (userId && !fetchSaved) {
      dispatch(fetchSavedNewsByUser(userId));
    }

    return () => {
      dispatch(setSavedNews(null))
      dispatch({ type: 'RESET_SAVED_NEWS_FETCH_FLAG' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userId])

  const handleShowComments = (e, news) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch({ type: 'FETCH_NEWS_BY_ID_SUCCESS', payload: news });
    setShowComments(true);
  };

  const handleCloseComments = () => {
    setShowComments(false);
  };

  return (
    <div className=''>
      <div className={styles.savedSection}>
        <div className={styles.verticalCardList}>
          {loading && !savedNews ? (
            <>
              {[1, 2, 3, 4].map((item) => (
                <NewsItemSkeleton key={item} />
              ))}
            </>
          ) : savedNews && savedNews.length > 0 ? (
            savedNews.map((item) => (
              <NewsItem news={item} key={item.id} handleShowComments={handleShowComments} type="saved" />
            ))
          ) : (
            <div>No saved news found.</div>
          )}
        </div>
      </div>
      {showComments && selectedNews && (
        <CommentSection
          creation_id={selectedNews.id}
          onClose={handleCloseComments}
          type="news"
        />
      )}
    </div>
  );
};

export default SavedNews; 